import type { IncomingHttpHeaders } from 'http';
import { donedealServicesGateway } from '../api/api-utils/commonApiUtils';
import { greenlightRegistrationLookupResponseSchema } from '../api/historyCheck.typed';

async function greenlightRegistrationLookup(
  reg: string,
  headers: IncomingHttpHeaders,
) {
  const response = await donedealServicesGateway.get(
    `/ddapi/v1/vehicle/available-report/${reg}`,
    { headers },
  );
  return greenlightRegistrationLookupResponseSchema.parse(response.data);
}

export { greenlightRegistrationLookup };
